import { ReactNode } from "react";
import styles from "./Content.module.css";

type ContentProps = {
  children: ReactNode;
};

function Content({ children }: ContentProps) {
  return (
    <div data-testid={"content"} className={styles["root"]}>
      {children}
    </div>
  );
}

export default Content;
